import queryString from 'query-string'
import { convertSortIntoColunaConfig } from 'util/SortPropsUtils';
import { OrdemColunaTabela } from 'view/component/Tabela/model/OrdemColunaTabela';


interface Params<T> {
  filtros?: T;
  ordem?: OrdemColunaTabela;
}

export class QueryParamsFormatter {
  static format(queryParams: any) {
    return queryString.stringify(queryParams, {arrayFormat: 'none', skipEmptyString: true, skipNull: true});
  }

  static decode(queryParams: string) {
    return queryString.parse(queryParams, {arrayFormat: 'none'});
  }

  static decodeWithOrder(queryParams?: string): Params<any> {
    if (queryParams === undefined || queryParams === '') {
      return {filtros: undefined, ordem: undefined};
    }

    const params = QueryParamsFormatter.decode(queryParams);
    let ordem: OrdemColunaTabela|undefined = undefined;

    if (params['sort'] !== undefined) {
      const stringSort = params['sort'] as string ?? '';
      ordem = convertSortIntoColunaConfig(stringSort);
      delete params['sort'];
    }

    return {
      filtros: params,
      ordem: ordem
    }
  }
}
